//TECHDEBT: We might need to make this recursive
export function transformToCamelCase(value) {
    if (value && (typeof value === 'object' || Array.isArray(value))) {
        for (var k in value) {
            if (typeof value[k] === 'object') {
                value[k] = transformToCamelCase(value[k]);
            }
            if (Array.isArray(value[k])) {
                for (var i in value[k]) {
                    value[k][i] = transformToCamelCase(value[k][i]);
                }
            }
            if (/^[A-Z]/.test(k) && Object.hasOwnProperty.call(value, k)) {
                value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                delete value[k];
            }
        }
    }
    return value;
}
